import { NavigationElement, OnPageNavigationAnchorLink } from '@ahc-digital/component-library';
import {
  ComponentParams,
  ComponentRendering,
  constants,
  GetServerSideComponentProps,
  LayoutServiceData,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { getAllPlaceholdersFromRouteData } from 'src/shared/placeholder-utils';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

type NavigationElementNoChildren = Omit<NavigationElement, 'children'>;

export interface N09OnPageNavigationAnchorLinkProps {
  rendering?: ComponentRendering & { params?: ComponentParams };
  params?: {
    RemoveTopMargin: boolean;
  } & ComponentParams;
  anchors?: NavigationElementNoChildren[];
}

export const Default = (props?: N09OnPageNavigationAnchorLinkProps): JSX.Element => {
  const { params, anchors, rendering } = props || {};
  const marketingRenderingName = useCreateMarketingRenderingHame(
    rendering?.componentName as string
  );

  if (!anchors) return <></>;

  const removeTopMargin = !!params?.RemoveTopMargin;

  return (
    <>
      <OnPageNavigationAnchorLink
        anchors={anchors}
        removeTopMargin={removeTopMargin}
        data-component={marketingRenderingName}
      />
    </>
  );
};

export const getServerSideProps: GetServerSideComponentProps = async (
  _rendering: ComponentRendering,
  layoutData: LayoutServiceData
) => {
  if (process.env.JSS_MODE === constants.JSS_MODE.DISCONNECTED) return { anchors: [] };
  if (!layoutData?.sitecore?.route) return { anchors: [] };

  const anchors = getAllPlaceholdersFromRouteData(layoutData.sitecore.route)
    .filter((rendering) =>
      'params' in rendering && rendering?.params
        ? 'AnchorLinkTargetName' in rendering.params && 'AnchorLinkDisplayName' in rendering.params
        : false
    )
    .map((rendering: ComponentRendering) =>
      rendering?.params
        ? ({
            navigationTitle: rendering?.params['AnchorLinkDisplayName'],
            url: `#${rendering?.params['AnchorLinkTargetName']}`,
          } as NavigationElementNoChildren)
        : {}
    )
    .slice(0, 5);

  return { anchors: anchors };
};
